/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_Multiple_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to merge the selected events?" |
*
* @param {Merge_Swal_Multiple_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_multiple_text = /** @type {((inputs?: Merge_Swal_Multiple_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_Multiple_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Etes-vous sur de vouloir fusionner les evenements selectionnes ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Möchten Sie die ausgewählten Ereignisse wirklich zusammenführen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vuoi davvero unire gli eventi selezionati?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы уверены, что хотите объединить выбранные события?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Está seguro de que desea fusionar los eventos seleccionados?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您确定要合并所选事件吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを結合してもよろしいですか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप वाकई चयनित इवेंट्स को मर्ज करना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tem certeza de que deseja mesclar os eventos selecionados?")
	return /** @type {LocalizedString} */ ("Are you sure you want to merge the selected events?")
});